import React, { useState } from "react";
import axios from "axios";

export default function Competition() {
  const [loading, setLoading] = useState(false);
  const [results, setResults] = useState([]);
  const [error, setError] = useState(null);
  const [filterPlatform, setFilterPlatform] = useState("all"); // all, facebook, tiktok
  const [filterType, setFilterType] = useState("all"); // all, image, video

  const handleGenerate = async () => {
    setLoading(true);
    setError(null);
    try {
      // Call backend scraping endpoint
      const res = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/api/competition/generate`,
        {}, // Add product URL or ID as needed
        { withCredentials: true }
      );
      setResults(res.data.results || []);
    } catch (err) {
      setError("Failed to generate competitor ads.");
    } finally {
      setLoading(false);
    }
  };

  const filteredResults = results.filter((item) => {
    const platformMatch = filterPlatform === "all" || item.platform === filterPlatform;
    const typeMatch = filterType === "all" || item.type === filterType;
    return platformMatch && typeMatch;
  });

  return (
    <div className="max-w-7xl mx-auto p-6">
      <h1 className="text-2xl font-bold mb-6">Competition</h1>

      <button
        onClick={handleGenerate}
        disabled={loading}
        className="mb-4 px-6 py-3 bg-primary text-white rounded hover:bg-secondary disabled:opacity-50"
      >
        {loading ? "Generating..." : "Generate Competitor Ads"}
      </button>

      {error && <div className="text-red-600 mb-4">{error}</div>}

      <div className="flex space-x-4 mb-6">
        <select
          className="border rounded p-2"
          value={filterPlatform}
          onChange={(e) => setFilterPlatform(e.target.value)}
        >
          <option value="all">All Platforms</option>
          <option value="facebook">Facebook</option>
          <option value="tiktok">TikTok</option>
        </select>

        <select
          className="border rounded p-2"
          value={filterType}
          onChange={(e) => setFilterType(e.target.value)}
        >
          <option value="all">All Types</option>
          <option value="image">Images</option>
          <option value="video">Videos</option>
        </select>
      </div>

      {filteredResults.length === 0 ? (
        <p>No competitor ads found.</p>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
          {filteredResults.map((item, i) => (
            <div key={i} className="border rounded shadow overflow-hidden">
              {item.type === "video" ? (
                <video
                  src={item.url}
                  controls
                  className="w-full h-48 object-cover"
                />
              ) : (
                <img
                  src={item.url}
                  alt={`Ad ${i + 1}`}
                  className="w-full h-48 object-cover"
                />
              )}
              <div className="p-3 flex justify-between items-center text-sm text-gray-600">
                <span>{item.platform}</span>
                <a
                  href={item.url}
                  download
                  className="text-blue-600 hover:underline"
                  target="_blank"
                  rel="noreferrer"
                >
                  Download
                </a>
              </div>
              {/* TODO: Add buttons for 'Add Voice', 'Add Subtitles', 'Add Watermark' */}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
